import { render } from "./NutritionWidget.vue?vue&type=template&id=020b25f8&scoped=true"
import script from "./NutritionWidget.vue?vue&type=script&lang=js"
export * from "./NutritionWidget.vue?vue&type=script&lang=js"

import "./NutritionWidget.vue?vue&type=style&index=0&id=020b25f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-020b25f8"]])

export default __exports__